"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.videoEvent = void 0;
var consts_1 = require("../consts");
var videoEvent = function (event, action) {
    var _a, _b, _c, _d;
    return {
        event: "video",
        eventInfo: "video",
        action: action,
        video: __assign(__assign({}, event.eventData), { videoID: ((_a = event.eventData) === null || _a === void 0 ? void 0 : _a.videoID) || consts_1.NOT_AVAILABLE, videoMetaTags: ((_b = event.eventData) === null || _b === void 0 ? void 0 : _b.videoMetaTags) || consts_1.NOT_AVAILABLE, videoTime: ((_c = event.eventData) === null || _c === void 0 ? void 0 : _c.videoTime) || consts_1.NOT_AVAILABLE, videoTitle: ((_d = event.eventData) === null || _d === void 0 ? void 0 : _d.videoTitle) || consts_1.NOT_AVAILABLE }),
    };
};
exports.videoEvent = videoEvent;
